import {makeid} from '../helpers/Helpers'
import {getAuthorizationSetting} from '../helpers/Helpers';
import jwtDecode from "jwt-decode";

export default {
    'name': process.env.APP_NAME,
    'api': {
        'endpoint': process.env.API_ENDPOINT,
        'cdn': process.env.CDN_ENDPOINT,
        getCdnEndPoint() {
            if (this.cdn) {
                return this.cdn
            } else {
                return this.endpoint;
            }
        }
    },
    'language': process.env.LANGUAGE,
    'prefix': 'csod-awave--',
    'adminURL': document.getElementById('application').getAttribute('data-admin-url'),
    'frontURL': document.getElementById('application').getAttribute('data-front-url'),
    'client': document.getElementById('application').getAttribute('data-client'),
    'renderer': document.getElementById('application').getAttribute('data-renderer'),
    'isAuthorizationOn': getAuthorizationSetting(document.getElementById('application').getAttribute('data-renderer'), document.getElementById('application').getAttribute('data-client')),
    getYoutubeApiKey() {
        return "AIzaSyAzk9iamqA4FNsFfk7-Kx66eYT3kLTRuL8";
    },
    destroy(key) {
        localStorage.removeItem(this.getStoragePrefixes(key));
    },
    set(key, value) {
        localStorage.setItem(this.getStoragePrefixes(key), value);
    },
    get(key) {
        let value = null;
        value = localStorage.getItem(this.getStoragePrefixes(key));

        if (value === "true") {
            return true;
        }
        if (value === "null") {
            return null;
        }
        if (value === "false") {
            return null;
        }

        return value;
    },
    clearStorage() {
        this.destroy('apitoken');
        this.destroy('user');
        this.destroy('roleId');
        this.destroy('ssoId');
    },
    managerViewOn() {
        return this.get('managersViewOn');
    },
    setManagersView(state) {
        this.set('managersViewOn', state);
    },
    setManagerToken(token) {
        this.set('managertoken', token);
    },
    setToken(token) {
        this.set('apitoken', token);
    },
    getToken() {
        let token = this.get('apitoken');

        if (token) {
            let expDate = parseInt(jwtDecode(token).exp, 10) * 1000;
            let currDate = Date.now();

            if (expDate < currDate) {
                this.clearStorage();
                return false;
            }
        }

        return token;
    },
    getRole() {
        let role = this.get('roleId');
        return role;
    },
    setRole(roleId) {
        return this.set('roleId', roleId);
    },

    setUserLoggedInGuid(userObj) {
        this.set("userLoggedInGuid", JSON.stringify(userObj))
    },

    setUser(userObj) {
        if (userObj) {
            this.set('user', JSON.stringify(userObj));
        } else {
            this.destroy('user');
        }
    },
    getUser() {
        let user = this.get('user');
        if (user) {
            return JSON.parse(user);
        }
        return null;
    },

    getUserLoggedInGuid() {
        let userLoggedInGuid = this.get('userLoggedInGuid');
        if (userLoggedInGuid) {
            return JSON.parse(userLoggedInGuid);
        }
        return null;
    },

    getApiConfig(params, originalToken) {

        let h = {
            'headers': {
                'pragma': 'no-cache'
            }
        };
        if (params) {
            Object.keys(params).map((key) => {
                h[key] = params[key];
                return null;
            });
        }
        let token = this.getToken();
        if (token && this.isAuthorizationOn) {
            h.headers = {
                ...h.headers,
                'Authorization': 'Bearer ' + this.getToken(originalToken),
            }
        }

        return h;
    },
    getId() {
        let id = localStorage.getItem("id");
        if (!id) {
            id = this.generateId();
        }
        return id;
    },
    getStoragePrefixes(key) {
        let id = this.getId();
        return id + "-" + this.renderer + "-" + key;
    },
    generateId() {
        var id = makeid();
        localStorage.setItem("id", id);
        return id;
    },
    getSsoLink(ssoId) {
        let id = ssoId ? ssoId : makeid();
        return this.api.endpoint + 'api/user/sso/' + id;
    },
    getSsoId() {
        return this.get('ssoId');
    },
    setSsoId(ssoId) {
        this.set('ssoId', ssoId);
    },
    getCurrentUser() {
        let user = this.getUser();
        return user;
    },
    getEntryPointUrl() {
        let entryPoint = this.get("entryPointUrl");
        if (entryPoint) {
            return entryPoint;
        }
        this.destroy("entryPointUrl");
        return null;
    },
    setEntryPointUrl(fullUrl) {
        this.set("entryPointUrl", fullUrl);
    },
    clearEntryPointUrl() {
        this.destroy("entryPointUrl");
    }
};



// WEBPACK FOOTER //
// ./src/config/index.js